import React from "react";

import { Paper } from "@/components/paper/Paper";
import { CreateLetterForm } from "@/features/mailbox/form/CreateLetterForm";
import { LadyMinV2DTO } from "@/models/lady-dtos";

type PropTypes = {
  ladyId?: number;
  ladyDto?: LadyMinV2DTO;
};

export const CreateLetterModal: React.FC<PropTypes> = ({ ladyId, ladyDto }) => {
  return (
    <Paper className=" w-[695px] max-w-full relative ">
      <CreateLetterForm ladyId={ladyId} ladyDto={ladyDto} />
    </Paper>
  );
};
